import { render } from "./EditButtonComponent.vue?vue&type=template&id=973b5cd0&scoped=true"
import script from "./EditButtonComponent.vue?vue&type=script&lang=js"
export * from "./EditButtonComponent.vue?vue&type=script&lang=js"

import "./EditButtonComponent.vue?vue&type=style&index=0&id=973b5cd0&lang=scss&scoped=true"

import exportComponent from "/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973b5cd0"]])

export default __exports__